import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import Button from 'core/elements/button'
import HostNetworkConfiguration, { defaultInterfaceConfig } from './HostNetworkConfiguration'
import { trackEvent } from 'utils/tracking'

const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    display: 'grid',
    gap: 16,
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}))

const defaultNetworkConfigValues = {
  name: '',
  networkInterfaces: [defaultInterfaceConfig],
}

export default function HostNetworkConfigurations({
  existingHostNetworkConfigs,
  params,
  updateParams,
}) {
  const classes = useStyles()

  const addConfiguration = useCallback(() => {
    updateParams({
      hostNetworkConfigs: [...params.hostNetworkConfigs, defaultNetworkConfigValues],
    })
    trackEvent(`Cluster Blueprint - Clicked Add Host Network Configuration`)
  }, [params.hostNetworkConfigs])

  return (
    <div className={classes.root}>
      {params?.hostNetworkConfigs?.map((config, idx) => (
        <div key={idx}>
          <HostNetworkConfiguration
            params={params}
            updateParams={updateParams}
            config={config}
            idx={idx}
            existingHostNetworkConfig={existingHostNetworkConfigs?.find(
              (c) => c.name === config.name,
            )}
          />
        </div>
      ))}
      <div className={classes.buttonRow}>
        <Button type="button" icon="plus" onClick={addConfiguration}>
          Add Host Configuration
        </Button>
      </div>
    </div>
  )
}
